module.exports = __webpack_public_path__ + "static/media/bottom-slide-up.56b23e0e.webp";